<template>
  <!-- <BannerTrafficParis v-if="path.match(/(\bparis\b)/)" /> -->
  <div :class="{ 'max-w-[900px] mx-auto': eventsListStore.viewType === ViewType.SLOTS }">
    <BaseFadeTransition>
      <EventsAreaRootDescription v-if="appStore.isDesktopScreen || eventsListStore.viewType !== ViewType.MAP" />
    </BaseFadeTransition>
    <EventsFiltersAndViewsContainerMobile />
    <EventsFiltersDesktop />
    <EventsMapView v-if="eventsListStore.viewType === ViewType.MAP" />
    <EventsList v-else-if="eventsListStore.viewType === ViewType.EVENTS" />
    <EventsCalendarView v-else />
  </div>
</template>

<script setup lang="ts">
import { ViewType } from "@/composables/types";
import { ATELIER_DEFAULT_DESCRIPTION } from "@/composables/atelierShareSeo";

const eventsListStore = useEventsListStore();
const appStore = useAppStore();

const handleFiltersFromURLAndFetch = async () => {
  eventsListStore.extractFiltersFromQueryParams();

  eventsListStore.fetchFilters();

  if (eventsListStore.viewTypeIsEventsOrMap) eventsListStore.fetchAteliers();
  else eventsListStore.fetchSlots();
};

const route = useRoute();
const slug = route.params.parent as string;

await eventsListStore.fetchAteliersPageInfo(slug);
// the fact line under the H1 names the city from the area
await eventsListStore.fetchArea();

if (!eventsListStore.pageInfo) {
  throw createError({ statusCode: 404, statusMessage: "Page non trouvée", fatal: true });
}

// to know if user is hitting the back button we store the previous url on this page
// if there is a previousRouteFullPath stored and it's matching the current url, we know it's a back button
// in that case we don't want to refetch the data so the scroll stay perfectly at the previous position
if (eventsListStore.previousRouteFullPath !== route.fullPath) handleFiltersFromURLAndFetch();

// this watcher update the filters and refetch based on what's in the URL
watch(
  () => route.query,
  () => handleFiltersFromURLAndFetch(),
);

onUnmounted(() => (eventsListStore.previousRouteFullPath = route.fullPath));

useSeoMeta({
  title: () => (eventsListStore.pageInfo ? `${eventsListStore.pageInfo.head_title} - IZIBABY` : "IZIBABY"),
  description: () => eventsListStore.pageInfo?.head_description || ATELIER_DEFAULT_DESCRIPTION,
  ogTitle: () => eventsListStore.pageInfo?.head_title || "IZIBABY",
  ogDescription: () => eventsListStore.pageInfo?.head_description || ATELIER_DEFAULT_DESCRIPTION,
  twitterTitle: () => eventsListStore.pageInfo?.head_title || "IZIBABY",
  twitterDescription: () => eventsListStore.pageInfo?.head_description || ATELIER_DEFAULT_DESCRIPTION,
});

useItemListSchema();
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
